import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {SegmentLineContainerModel} from '../../../../../../models/aggregates/dgmkt/dgmkt-segment';

@Injectable({
  providedIn: 'root',
})
export class DgMktSegmentLineService extends BaseApiTemplateService<SegmentLineContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'segment-lines/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'segment-lines/backoffice-ep';
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'segment-lines/backoffice-ep';
    this.httpClient = http;
  }
}
